
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const PainPoints = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation<HTMLDivElement>();
  const { ref: gridRef, visibleItems } = useStaggeredAnimation<HTMLDivElement>(8, 150);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation<HTMLDivElement>();

  const painPoints = [
    "You're spending crazy money on other dispositions software",
    "You're drowning in \"tire-kicker\" buyers who waste your time but never close",
    "Your deals are sitting unsold for weeks while holding costs eat into your profits",
    "You're forced to slash your assignment fees just to move properties quickly",
    "You're getting crushed by competition from newer wholesalers who undercut you",
    "You're spending a fortune on marketing but can't build a reliable buyer list",
    "You're working 60+ hour weeks but your income is stuck or even declining",
    "Your current software is too complex and takes too much time to use"
  ];

  return (
    <section className="pt-9 pb-16 bg-card/30">
      <div className="container mx-auto px-4">
        <div 
          ref={headerRef}
          className={`text-center mb-12 transition-all duration-700 ${
            headerVisible ? 'animate-fade-in translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">WHICH OF THESE OFF MARKET DEAL NIGHTMARES<br/>ARE KILLING YOUR PROFITS?</h2>
        </div>

        <div 
          ref={gridRef}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8 max-w-4xl mx-auto"
        >
          {painPoints.map((point, index) => (
            <div 
              key={index} 
              className={`flex items-start gap-3 transition-all duration-700 ${
                visibleItems.includes(index) 
                  ? 'animate-fade-in translate-y-0 opacity-100' 
                  : 'translate-y-8 opacity-0'
              }`}
              style={{
                transitionDelay: visibleItems.includes(index) ? `${index * 150}ms` : '0ms'
              }}
            >
              <div className="h-6 w-6 mt-1 flex-shrink-0 rounded-full bg-godyspo-gold flex items-center justify-center">
                <CheckCircle className="h-5 w-5 text-godyspo-background" />
              </div>
              <p className="text-lg">{point}</p>
            </div>
          ))}
        </div>

        <div 
          ref={ctaRef}
          className={`text-center mt-10 transition-all duration-700 ${
            ctaVisible ? 'animate-fade-in animate-scale-in translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <p className="text-lg mb-2">If any of these sound familiar, you're not alone. But here's the good news:</p>
          <p className="text-2xl font-bold text-godyspo-gold">There's a better way.</p>
          
          <div className="mt-8">
            <Link to="/pricing">
              <Button size="lg" className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90">
                Solve These Problems Now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
